import { render } from "./QuotaBalanceTab.vue?vue&type=template&id=a5360d18&scoped=true"
import script from "./QuotaBalanceTab.vue?vue&type=script&lang=js"
export * from "./QuotaBalanceTab.vue?vue&type=script&lang=js"

import "./QuotaBalanceTab.vue?vue&type=style&index=0&id=a5360d18&lang=scss&scoped=true"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5360d18"]])

export default __exports__